export var props = {
  rewards: {
    type: Array,
    required: true,
    default: () => []
  },
  rewardTitle: {
    type: String,
    required: false,
    default: '奖励'
  },
  fieldsGetter: {
    type: Object,
    required: false,
    default: () => {
      return {
        img: 'img',
        title: 'title',
        value: 'value',
        tag: 'tag'
      };
    }
  }
};